
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_14yj0_qrzwj_93",
  "no-gutters": "awsui_no-gutters_14yj0_qrzwj_132",
  "grid-column": "awsui_grid-column_14yj0_qrzwj_137",
  "colspan-1": "awsui_colspan-1_14yj0_qrzwj_148",
  "push-1": "awsui_push-1_14yj0_qrzwj_152",
  "pull-1": "awsui_pull-1_14yj0_qrzwj_155",
  "colspan-2": "awsui_colspan-2_14yj0_qrzwj_158",
  "push-2": "awsui_push-2_14yj0_qrzwj_162",
  "pull-2": "awsui_pull-2_14yj0_qrzwj_165",
  "colspan-3": "awsui_colspan-3_14yj0_qrzwj_168",
  "push-3": "awsui_push-3_14yj0_qrzwj_172",
  "pull-3": "awsui_pull-3_14yj0_qrzwj_175",
  "colspan-4": "awsui_colspan-4_14yj0_qrzwj_178",
  "push-4": "awsui_push-4_14yj0_qrzwj_182",
  "pull-4": "awsui_pull-4_14yj0_qrzwj_185",
  "colspan-5": "awsui_colspan-5_14yj0_qrzwj_188",
  "push-5": "awsui_push-5_14yj0_qrzwj_192",
  "pull-5": "awsui_pull-5_14yj0_qrzwj_195",
  "colspan-6": "awsui_colspan-6_14yj0_qrzwj_198",
  "push-6": "awsui_push-6_14yj0_qrzwj_202",
  "pull-6": "awsui_pull-6_14yj0_qrzwj_205",
  "colspan-7": "awsui_colspan-7_14yj0_qrzwj_208",
  "push-7": "awsui_push-7_14yj0_qrzwj_212",
  "pull-7": "awsui_pull-7_14yj0_qrzwj_215",
  "colspan-8": "awsui_colspan-8_14yj0_qrzwj_218",
  "push-8": "awsui_push-8_14yj0_qrzwj_222",
  "pull-8": "awsui_pull-8_14yj0_qrzwj_225",
  "colspan-9": "awsui_colspan-9_14yj0_qrzwj_228",
  "push-9": "awsui_push-9_14yj0_qrzwj_232",
  "pull-9": "awsui_pull-9_14yj0_qrzwj_235",
  "colspan-10": "awsui_colspan-10_14yj0_qrzwj_238",
  "push-10": "awsui_push-10_14yj0_qrzwj_242",
  "pull-10": "awsui_pull-10_14yj0_qrzwj_245",
  "colspan-11": "awsui_colspan-11_14yj0_qrzwj_248",
  "push-11": "awsui_push-11_14yj0_qrzwj_252",
  "pull-11": "awsui_pull-11_14yj0_qrzwj_255",
  "colspan-12": "awsui_colspan-12_14yj0_qrzwj_258",
  "push-12": "awsui_push-12_14yj0_qrzwj_262",
  "pull-12": "awsui_pull-12_14yj0_qrzwj_265",
  "push-0": "awsui_push-0_14yj0_qrzwj_268",
  "pull-0": "awsui_pull-0_14yj0_qrzwj_271",
  "offset-1": "awsui_offset-1_14yj0_qrzwj_274",
  "offset-2": "awsui_offset-2_14yj0_qrzwj_277",
  "offset-3": "awsui_offset-3_14yj0_qrzwj_280",
  "offset-4": "awsui_offset-4_14yj0_qrzwj_283",
  "offset-5": "awsui_offset-5_14yj0_qrzwj_286",
  "offset-6": "awsui_offset-6_14yj0_qrzwj_289",
  "offset-7": "awsui_offset-7_14yj0_qrzwj_292",
  "offset-8": "awsui_offset-8_14yj0_qrzwj_295",
  "offset-9": "awsui_offset-9_14yj0_qrzwj_298",
  "offset-10": "awsui_offset-10_14yj0_qrzwj_301",
  "offset-11": "awsui_offset-11_14yj0_qrzwj_304",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_qrzwj_308"
};
  